module.exports = __webpack_public_path__ + "static/media/restoreLife.b85e3286.svg";